
import Auth from './../auth/Auth.js'
import Vue from 'vue';

Vue.use({
  install (Vue) {
    
    const options = {
      
      urls : {
        login : 'auth/login',
        logout : 'auth/logout',
        userData : 'auth/userData',
      },
      
      redirect : {
        home : '/',
        login : '/login',
      },

      getTokenFunction: (response) => response.token,
      
    }

    let auth = new Auth(options)

    Vue.prototype.$auth = auth
    Vue.$auth = auth;
  }
})

export default (_) => { }